<template>
  <div class="toolbox" id="query-panel">
    <h4 class="container-title">
      Data
    </h4>
    <table>
      <tr>
        <td class="label">Show</td>
        <td>
          <select-control
            v-model="queryStatisticId"
            :options="allStatistics"
            label="label" />
        </td>
      </tr>
      <tr v-show="enableChildrenControl">
        <td></td>
        <td>
          <select-control
            v-if="enableChildrenControl"
            v-model="queryStatisticSubId"
            :options="availableStatisticChildren"
            label="label" />
        </td>
      </tr>
      <tr v-show="enableMultiControl">
        <td></td>
        <td>
          <select-control
            v-if="enableMultiControl"
            v-model="queryOrganMode"
            :options="availableOrganModes"
            label="label"/>
        </td>
      </tr>
      <tr>
        <td class="label">Year</td>
        <td>
          <select-control
            v-model="queryYear"
            :options="allYears"
            label="label"/>
        </td>
      </tr>
      <tr>
        <td class="label">Group by</td>
        <td>
          <select-control
            v-model="queryRegionMode"
            :options="availableRegionModes"
            label="label"/>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import SelectControl from '../SelectControl'
import { mapGetters } from 'vuex'

export default {
  name: 'QueryPanel',

  components: { SelectControl },

  data () {
    return {
      legendMin: 'n/a',
      legendMax: 'n/a',
      visible: true
    }
  },

  computed: {
    /**
     * Return a list of valid Children for selected Staistic.
     * Used to populate one of the SelectControl.
     */
    availableStatisticChildren: function () {
      return this.selectedStatistic.children
    },

    /**
     * Return a list valid available Organ Modes for selected Statistic.
     * Used to populate one of the SelectControl.
     */
    availableOrganModes: function () {
      if (!this.selectedStatistic) {
        return []
      }

      let availableOrganModesIds = this.selectedStatistic.organs
      return this.allOrganModes.filter(function (organMode) {
        return availableOrganModesIds.indexOf(organMode.value) >= 0
      })
    },

    /**
     * Return a list valid available Region Modes for selected Statistic.
     * Used to populate one of the SelectControl.
     */
    availableRegionModes: function () {
      if (!this.selectedStatistic) {
        return []
      }

      let availableRegionModeIds = this.selectedStatistic.regions
      return this.allRegionModes.filter(function (regionMode) {
        return availableRegionModeIds.indexOf(regionMode.value) >= 0
      })
    },

    /**
     * True if selected Statistic supports single/multi organ switch.
     * Used to show/hide one of the SelectControl.
     */
    enableMultiControl: function () {
      return this.selectedStatistic && this.selectedStatistic.organs.length > 0
    },

    /**
     * True if selected Statistic has Children.
     * Used to show/hide one of the SelectControl.
     */
    enableChildrenControl: function () {
      return this.selectedStatistic && this.selectedStatistic.children.length > 0
    },

    ...mapGetters({
      allOrganModes: 'allOrganModes',
      allRegionModes: 'allRegionModes',
      allStatistics: 'allStatistics',
      allYears: 'allYears',
      selectedStatistic: 'selectedStatistic'
    }),

    queryOrganMode: {
      get () { return this.$store.state.queryOrganMode },
      set (v) { this.$store.commit('queryOrganMode', v) }
    },

    queryRegionMode: {
      get () { return this.$store.state.queryRegionMode },
      set (v) { this.$store.commit('queryRegionMode', v) }
    },

    queryStatisticId: {
      get () { return this.$store.state.queryStatisticId },
      set (v) {
        // Cache queryRegionMode
        let prevRegionMode = this.queryRegionMode

        // Update selected statistic
        this.$store.commit('queryStatisticId', v)
        this.$store.commit('queryStatisticSubId', this.selectedStatistic.children.length === 0 ? false : this.selectedStatistic.children[0].value)

        // Force Region mode change, if necessary
        let regionCompatible = false
        let availableRegions = this.availableRegionModes
        for (let i = 0; i < availableRegions.length && !regionCompatible; i++) {
          regionCompatible = regionCompatible || availableRegions[i].value === prevRegionMode
        }
        if (!regionCompatible) {
          this.$store.commit('queryRegionMode', availableRegions[0].value)
          this.$store.commit('selectRegion', null)
        }
      }
    },

    queryStatisticSubId: {
      get () { return this.$store.state.queryStatisticSubId },
      set (v) { this.$store.commit('queryStatisticSubId', v) }
    },

    queryYear: {
      get () { return this.$store.state.queryYear },
      set (v) { this.$store.commit('queryYear', v) }
    }
  }
}
</script>

<style scoped>
table {
  border: 0;
  border-collapse: collapse;
}

.label {
  padding-right: .5rem;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Toolboxes/QueryPanel.vue